module.exports = __webpack_public_path__ + "img/蒙版组 9@2x.24c4436f.png";